module.exports = __webpack_public_path__ + "img/OKIS-J-18.b60be1e0.svg";